export default __webpack_public_path__ + "static/Icon-calendar-7364963fa5e7a672521448f9deaf8d8e.svg";